import Swal from "sweetalert2";
import { useDeleteJobMutation } from "../../../services/apiSlice";

// const Delete = async (jobId) => {
//   const [DeleteJob, { data, error, isError }] = useDeleteJobMutation();
//   return Swal.fire({
//     title: "Are you sure?",
//     text: "You won't be able to revert this!",
//     icon: "warning",
//     showCancelButton: true,
//     confirmButtonColor: "#3085d6",
//     cancelButtonColor: "#d33",
//     confirmButtonText: "Yes, delete it!",
//   }).then(async (result) => {
//     if (result.isConfirmed) {
//       await DeleteJob(jobId);
//       Swal.fire("Deleted!", `  ${data?.message}`, "success");
//     }
//   });
// };

// export default Delete;
import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { red } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DeleteModal({ jobId }) {
  const [DeleteJob, { data, error, isError }] = useDeleteJobMutation();
  const [open, setOpen] = React.useState(false);
  console.log("jobID", jobId);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const navigate = useNavigate;
  const onSubmit = async () => {
    try {
      const responseData = await DeleteJob(jobId).unwrap();
      console.log(
        { responseData },
        "responseData?.message",
        responseData?.message
      );
      if (responseData?.success === true) {
        // success message
        Swal.fire("Awesome!", `  ${responseData?.message}`, "success").then(
          (result) => {
            if (result.isConfirmed || result.isDismissed) {
              //   navigate(0);
            }
          }
        );
      } else if (isError) {
        //error
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      } else if (responseData?.success === false) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      } else if (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      } else {
        console.log("error", error?.data?.message);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      }
    } catch (error) {
      if (isError) {
        //error
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      } else {
        console.log("error", error?.data?.message);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      }
    }
    console.log(data);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button onClick={handleClickOpen}>
        <IconButton>
          <DeleteIcon sx={{ color: red[600] }} />
        </IconButton>
      </Button>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Delete Job?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Are you sure?, You won't be able to revert this!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={async () => {
              onSubmit();
              // handleClose();
            }}
          >
            Yes delete it
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
